import { Action } from '@components/MultipleActionsInterfaces';
import { ArrowRightLeft, Trash2 } from 'lucide-react';
import LangEnum from '../../../../../lang/LangEnum';

export type CatalogMassActionType = 'remove_batch' | 'move_to_section_batch';

interface BuildCatalogMassActionsParams {
  isManualGroupingEffective: boolean;
  isDynamic: boolean;
  isSelectAllByFilter: boolean;
}

export const buildCatalogMassActions = ({
  isManualGroupingEffective,
  isDynamic,
  isSelectAllByFilter,
}: BuildCatalogMassActionsParams): Action<CatalogMassActionType>[] => {
  const actions: Action<CatalogMassActionType>[] = [];

  if (!isDynamic && !isSelectAllByFilter) {
    actions.push({
      label: LangEnum.CATALOGS_MASS_ACTIONS_REMOVE_FROM_CATALOG,
      icon: Trash2,
      type: 'remove_batch',
      isMassAction: true,
      showShortcut: true,
    });
  }

  if (isManualGroupingEffective) {
    actions.push({
      label: LangEnum.CATALOGS_MASS_ACTIONS_MOVE_TO_SECTION,
      icon: ArrowRightLeft,
      type: 'move_to_section_batch',
      isMassAction: true,
    });
  }

  return actions;
};
